import apiFetch from 'api/base'
import { AxiosPromise } from 'axios'
import { ILanguage } from 'static/languages'

const loginByGoogle = (data: {
  visitorId: string
  providerUserToken?: string
  language?: ILanguage['locale']
}): AxiosPromise => apiFetch(`/socialauth/login/google`, { data, method: `POST` })

export default loginByGoogle
